import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { OptionalHolidayService } from '../../../Model/OptionalHoliday/optional-holiday.service';
import { Session } from 'inspector';
import { SessionService } from '../../../Util/Session/session.service';
import { CommonService } from '../../../Model/Common/common.service';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { Router } from '@angular/router';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';

@Component({
  selector: 'app-optional-holiday-form',
  standalone: true,
  imports: [FormsModule, CommonModule, NgbDropdownModule, NgSelectModule],
  templateUrl: './optional-holiday-form.component.html',
  styleUrl: './optional-holiday-form.component.scss'
})
export class OptionalHolidayFormComponent {
  isDisabled: boolean = false;
  //activeModal = inject(NgbActiveModal);
  Filter = {
    SelectType: 1,
    ESS_CompanyHolidayMasterID: null,
    EmpMasterID: 0,
    ESS_EmployeeOptionalHolidayId: 0,
    FromDate: null,
    ToDate: null,
    ApprovalStatus: 'ALL',
  }

  FormFilter = {
    SelectType: 'I',
    Date: null,
    Type: null,
    HolidayType: null,
    Remark: null,
    SiteId: null,
    BranchId: null
  }

  OpHolidays = [] as any;

  constructor(
    private optionalholiday: OptionalHolidayService,
    private session: SessionService,
    protected common: CommonService,
    private modalService: NgbModal,
    private router: Router,
    private tooltip: TooltipService,
    private toast: ToastService,
  ) {
    this.common.getPageRights();
  }

  ngOnInit(): void {
    this.Filter.EmpMasterID = this.session.GetUserDetails().UserId;
    this.ESS_EmployeeOptionalHolidayLoadGet();
  }

  FilterValidate(form: any) {
    if (form.valid) {
      this.ESS_EmployeeOptionalHolidaySave();
    }
    else {
      form.submitted = true;
    }
  }

  ESS_EmployeeOptionalHolidayLoadGet() {
    this.isDisabled = true;
    this.optionalholiday.ESS_EmployeeOptionalHolidayLoadGet(this.Filter).subscribe({
      next: (response) => {
        try {
          if (response.Table.length > 0) {
            this.OpHolidays = response.Table;
          } else {
            this.OpHolidays = [];
          }
        } catch (e) {
          this.OpHolidays = [];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async ESS_EmployeeOptionalHolidaySave() {
    this.isDisabled = true;
    await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to save?';
    modalRef.result.then(result => {
      if (this.common.PageRight.IsAdd) {
        if (result) {
          this.isDisabled = true;
          this.optionalholiday.ESS_EmployeeOptionalHolidaySave({
            SelectType: this.FormFilter.SelectType,
            ESS_EmployeeOptionalHolidayId: this.Filter.ESS_EmployeeOptionalHolidayId, EmpMasterID: this.Filter.EmpMasterID,
            ESS_CompanyHolidayMasterID: this.Filter.ESS_CompanyHolidayMasterID, SiteId: this.FormFilter.SiteId, BranchId: this.FormFilter.BranchId,
            Remarks: this.FormFilter.Remark
          }).subscribe({
            next: (response) => {
              if (response.Error_Code == '401') {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.router.navigate(['/request/optionalholiday/']);
                  }
                });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    });
  }

  setOtherDetail() {
    this.FormFilter.Date = this.OpHolidays.filter((e: any) => e.ESS_CompanyHolidayMasterID == this.Filter.ESS_CompanyHolidayMasterID)[0].Date;
    this.FormFilter.Type = this.OpHolidays.filter((e: any) => e.ESS_CompanyHolidayMasterID == this.Filter.ESS_CompanyHolidayMasterID)[0].TypesOfLeave;
    this.FormFilter.HolidayType = this.OpHolidays.filter((e: any) => e.ESS_CompanyHolidayMasterID == this.Filter.ESS_CompanyHolidayMasterID)[0].HolidayType;
    this.FormFilter.SiteId = this.OpHolidays.filter((e: any) => e.ESS_CompanyHolidayMasterID == this.Filter.ESS_CompanyHolidayMasterID)[0].SiteMasterId;
    this.FormFilter.BranchId = this.OpHolidays.filter((e: any) => e.ESS_CompanyHolidayMasterID == this.Filter.ESS_CompanyHolidayMasterID)[0].BranchMasterID;
  }

  close() {
    //this.activeModal.close();
    this.router.navigate(['/request/optionalholiday/']);
  }
}
